const usePrerender = () => {
  const isPrerender = /prerender/i.test(navigator.userAgent)

  return { isPrerender }
}

export default usePrerender
